import React from "react";
import { pressLogos, earnedMediaLogos } from "../../mock";
import { ArrowRight } from "lucide-react";

const Marquee = ({ items, reverse }) => (
  <div className="overflow-hidden py-2">
    <div className="marquee-track" style={reverse ? { animationDirection: "reverse" } : {}}>
      {[...items, ...items].map((name, i) => (
        <span
          key={i}
          className="flex-shrink-0 mx-8 md:mx-12 font-serif-display text-2xl md:text-3xl text-neutral-400 whitespace-nowrap"
        >
          {name}
        </span>
      ))}
    </div>
  </div>
);

const MediaLogos = () => {
  return (
    <section id="media" className="bg-[#f3f1ec] py-24 md:py-32">
      <div className="max-w-[1300px] mx-auto px-6 md:px-10 text-center mb-16 reveal">
        <p className="text-[11px] tracking-luxe uppercase text-[#b4936a] mb-4">As Featured In</p>
        <h2 className="font-serif-display text-4xl md:text-6xl font-light text-[#1a1a1a]">Earned Media</h2>
        <p className="text-neutral-500 text-[15px] leading-relaxed max-w-2xl mx-auto mt-6">
          From market insights to viral social media moments, Capital Corner Group is consistently at the center of the conversation.
        </p>
      </div>

      <div className="space-y-4 mb-16">
        <Marquee items={pressLogos} />
        <Marquee items={earnedMediaLogos} reverse />
      </div>

      <div className="text-center reveal">
        <a href="#media" className="inline-flex items-center gap-2 text-[11px] tracking-luxe uppercase text-[#1a1a1a] hover:text-[#b4936a] transition-colors border border-[#1a1a1a] hover:border-[#b4936a] px-8 py-4">
          View Press <ArrowRight size={14} />
        </a>
      </div>
    </section>
  );
};

export default MediaLogos;
